exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".employee-form-item[data-v-20c51771]{margin-right:2em}.filter-container[data-v-20c51771]{display:inline-flex;align-items:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-20c51771&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./app/components/ia/EmployeeFilter.vue
// module id = 237
// module chunks = 0